import { SidebarContext } from '@/contexts';
import { ComponentType, PropsWithChildren, useState } from 'react';

export interface SidebarContextType {
  showSidebar: boolean;
  onChangeShowSidebar: (show?: boolean) => void;
}

export const SidebarProvider: ComponentType<PropsWithChildren> = ({
  children,
}) => {
  const [showSidebar, setShowSidebar] = useState(false);

  const onChangeShowSidebar = (show?: boolean) => {
    setShowSidebar(show ?? !showSidebar);
  };

  return (
    <SidebarContext.Provider value={{ showSidebar, onChangeShowSidebar }}>
      {children}
    </SidebarContext.Provider>
  );
};
